type ErrorTextProps = {
  message: string;
  className?: string;
};

export default function ErrorText({ message, className }: ErrorTextProps) {
  return (
    <div className={`mx-auto text-error ${className ? className : ''}`}>
      <p>{message}</p>
    </div>
  );
}
